import { useApiPost } from '@sierralabs/core-ui';
export function useCreateSite() {
    const { data, isLoading, error, post } = useApiPost('sites');
    return { createdSite: data, isCreating: isLoading, error, createSite: post };
}
//# sourceMappingURL=useCreateSite.js.map